// extracted by css-extract-rspack-plugin
export default {"content":"gc3T6","mobile":"kWKlf","desktop":"rR0Uw","info":"MisbJ","image":"BQGK8","progress":"WOwkU","amountTitle":"fxEk2","progressBar":"RiotB"};